import { FC } from 'react';
import {
  EntitySearchTextFilter,
  EntityTagPicker,
  UserListPicker,
  WbTableFilters,
} from '@agilelab/plugin-wb-platform';
import { OutputTypePicker } from '@agilelab/plugin-wb-practice-shaper';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useScaffolderPageContext } from './context/useScaffolderPageContext';

export const ScaffolderFilters: FC = () => {
  const { filters, updateFilters } = useScaffolderPageContext();
  const configApi = useApi(configApiRef);

  return (
    <WbTableFilters
      style={{ flex: 1 }}
      searchValue={filters.text?.value}
      onSearch={value => {
        updateFilters({ text: new EntitySearchTextFilter(value, configApi) });
      }}
      onClear={() => {
        updateFilters({
          type: undefined,
          tags: undefined,
          user: undefined,
          text: undefined,
        });
      }}
    >
      <OutputTypePicker />
      <EntityTagPicker />
      <UserListPicker />
    </WbTableFilters>
  );
};
